import React from 'react';
import he from 'he';

export interface IDecoderProps {
  text: string;
}

export default function Decoder({ text }: IDecoderProps) {
  return <>{he.decode(text)}</>;
}
